import { Folder, Handshake, Work } from '@mui/icons-material';
import { InstitutionType } from '../../types/Institution';
import { SvgIconProps } from '@mui/material';

interface Props extends SvgIconProps {
    type: InstitutionType;
    size?: number;
    sx?: SvgIconProps['sx'];
}

const InstitutionIcon = ({ type, size, ...iconProps }: Props) => {
    const props = {
        sx: { height: size, width: size, ...iconProps.sx }
    };
    switch (type) {
        case InstitutionType.Association:
            return <Handshake {...props} />;
        case InstitutionType.Administration:
            return <Folder {...props} />;
        case InstitutionType.Company:
            return <Work {...props} />;
    }
};

export { InstitutionIcon };
